module.exports = __webpack_public_path__ + "img/desc.edb2889e.svg";